import './App.css';
import Dash from './components/dash/dash.component';
import { useStoreState, useStoreActions } from 'easy-peasy';
import firebaseService from './services/firebase.service';
import { useEffect, useState } from 'react';
import ErrorBoundary from './components/common/ErrorBoundary';
import ToastNotification from './components/common/ToastNotification';

function App() {
	const [loading, setLoading] = useState(true);
	const authorized = useStoreState((state) => state.authorized);
	const setAuthorized = useStoreActions((actions) => actions.setAuthorized);
	const setUnauthorized = useStoreActions(
		(actions) => actions.setUnauthorized
	);

	const authStateListener = () => {
		firebaseService.auth.onAuthStateChanged(async (user) => {
			if (!user) {
				setLoading(false);
				return setUnauthorized();
			}

			// Extract user data
			const userData = {
				uid: user.uid,
				email: user.email,
				displayName: user.displayName,
				photoURL: user.photoURL
			};

			setLoading(false);
			return setAuthorized(userData);
		});
	};

	useEffect(() => {
		authStateListener();
	}, [authStateListener]);

	return (
		<ErrorBoundary>
			<ToastNotification />
			<div className="App">
				{loading ? <p>Loading...</p> : <Dash authorized={authorized} />}
			</div>
		</ErrorBoundary>
	);
}

export default App;
